import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Trailer } from './trailer.service';
import { BaseHttpService, PageResponse } from 'src/app/auth/base-capacitor-http';
import { MatSnackBar } from '@angular/material/snack-bar';

export enum YardUpdateOption{
  UPDATE = 'UPDATE',
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN',
}

export enum YardStatus{
  OCCUPIED = 'OCCUPIED',
  EMPTY = 'EMPTY',
  OUT_OF_SERVICE = 'OUT_OF_SERVICE',
  OUTGOING = 'OUTGOING',
  INCOMING = 'INCOMING'
}

export class Yard{
  id: string;
  location: string;
  status: string;
  trailerId: string;
  instance: number;
  trailer: Trailer = new Trailer();
}
export class YardSearchParams {
  page: number = 0;
  size: number = 10;
  search: string = YardStatus.EMPTY;
  type: YardSearchType = YardSearchType.STATUS;
}

export enum YardSearchType{
  TRAILER = 'TRAILER',
  STATUS = 'STATUS',
  ALL = 'ALL'
}

@Injectable({
  providedIn: 'root',
})

export class YardService extends BaseHttpService {
  private readonly baseURL: string = environment.server.mainURL;
  private endPointURL: string;
  
  constructor(client: HttpClient, snackbar: MatSnackBar) {
    super(client, snackbar);
  }
  getAllYardStatus(): string[]{
    return Object.values(YardStatus);
  }

  /**
   * This methods is meant to be used to add bulk data in the event that a user creates a new
   * instance and uploads data. For this reason the yard collection  will not be used
   * since thi is meant to be a new instance. and new collection for that instance is defined
   * in method.
   * @param yardList
   * @returns
   */

  async addBatchYardLocations(yardList: Yard[]): Promise<Yard[]> {
    this.endPointURL = this.baseURL + 'yard';
    return this.post<Yard[]>(this.endPointURL, yardList);
  }

  async getAllYardSpots(page: number, size: number): Promise<PageResponse<Yard>> {
    this.endPointURL = this.baseURL + 'yard';
    let params = {
      page: page,
      size: size
    }
    return this.get<PageResponse<Yard>>(this.endPointURL, params);
  }
  async getAllOpenYards(){
    this.endPointURL = this.baseURL + 'open-yards'
    let params = {
      status: 'EMPTY'
    }
    return this.get<Yard[]>(this.endPointURL, params);
  }
   /**
   * this queries the data base and ets all the available yard spots by status
   */
  async searchYards(params: YardSearchParams): Promise<PageResponse<Yard>> {
    this.endPointURL = this.baseURL + 'yard-search';
    return this.get<PageResponse<Yard>>(this.endPointURL, params);
  }
 /**
   * This method can be used to update and to add a new yard location
   * @param yard
   * @returns
   */
  async updateYard(update: string, yard: Yard): Promise<Yard> {
    this.endPointURL = this.baseURL + 'yard';
    let body = {
      trailer: JSON.stringify(yard.trailer),
      yard: JSON.stringify(yard)
    }
    return this.put<Yard>(this.endPointURL, body, { update });
  }
  

}
